export default __webpack_public_path__ + "static/media/dog-rMAX.jpg.048c6916.txt";